module.exports = __webpack_public_path__ + "img/stories-from-the-tenants-downstairs.4dc561bc.png";